import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { Avatar, Paper } from "@material-ui/core";
import Img from "react-webp-image";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    overflow: "hidden",
    padding: theme.spacing(0, 3),
    alignSelf: 'center'
  },
  paper: {
    maxWidth: 800,
    margin: `${theme.spacing(1)}px auto`,
    padding: theme.spacing(2)
  },
  image: {
    maxHeight: window.screen.height / 10,
    maxWidth: window.screen.width / 3,
  }
}));


export default function Question({ question, questionImage }) {
  const classes = useStyles();

  if (questionImage != undefined && questionImage != "") {
    let qImage = questionImage.split("~");

    return (
      <div className={classes.root}>
        <Grid container spacing={3} justify="center"
          alignItems="center">
          <Grid item xs={12} justify="center"
            alignItems="center">
            <Typography variant="body2" align="center">
              <Img webp={qImage[0]} alt="webp image" className={classes.image} />
            </Typography>
          </Grid>
          <Grid item xs={12} >

            <Typography variant="body2" align="center">{question}</Typography>

          </Grid>

        </Grid>

      </div>
    );
  }



  return (
    <div className={classes.root}>
      {/* <Paper onClick={()=>{console.log("Paper Clicked")}} className={classes.paper}> */}
      <Grid container wrap="nowrap" spacing={2}>
        {/* <Grid item>
            <Avatar>Q.</Avatar>
          </Grid> */}
        <Grid item xs >
          <Typography variant="body2" align="center">{question}</Typography>
        </Grid>
      </Grid>
      {/* </Paper> */}


    </div>
  );
}
